const useUpdatedFields = ({
  workFlowFields,
  poolList,
  selectedFrequency,
  poolMembers,
}) => {

  return workFlowFields.map((field) => {
    if (field.name === "workflow_type_id" && Array.isArray(poolList)) {
      return {
        ...field,
        options: poolList.map((pool) => pool.pool_name),
        values: poolList.map((pool) => pool.pool_id),
      };
    }

if (
  (field.name === "owner_id" || field.name === "collaborated_by") &&
  Array.isArray(poolMembers)
) {
  return {
    ...field,
    options: poolMembers.map((member) => member.user_first_name),
    values: poolMembers.map((member) => member.user_id),
  };
}
    if (field.name === "interval") {
      return {
        ...field,
        hidden: selectedFrequency !== "recurrent",
      };
    }

    return field;
  });
};

export default useUpdatedFields;
